<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">매출통계</span>
            <span class="txt">매출과 관련한 통계를 확인합니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="[...yearList]"
                    :select-value="[...yearValueList]"
                    :selected-value="yearDate"
                    class="w130"
                    @update:set="(val) => (yearDate = val)"
                ></select-form>
                <select-form
                    :select-data="[...monthList]"
                    :select-value="[...monthValueList]"
                    :selected-value="startDate"
                    class="w100"
                    @update:set="(val) => (startDate = val)"
                ></select-form>
                <div class="com-dash"><span class="dash">~</span></div>
                <select-form
                    :select-data="[...monthList]"
                    :select-value="[...monthValueList]"
                    :selected-value="endDate"
                    class="w100"
                    @update:set="(val) => (endDate = val)"
                ></select-form>
            </div>
        </div>

        <div class="graph-content">
            <div class="graph-area">
                <div class="half">
                    <span class="title">결제수단별 매출 현황</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart
                            :options="options"
                            :series="series"
                            :colors="colors"
                            height="500"
                            type="line"
                        ></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">이용권구분별 매출 현황</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="options2" :series="series2" height="500" type="line"></apexchart>
                    </div>
                </div>
            </div>
            <div class="graph-area">
                <div class="half">
                    <span class="title">신규 / 재등록 현황</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="options3" :series="series3" height="500" type="line"></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">지출현황</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="options4" :series="series4" height="500" type="line"></apexchart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'StatsSale',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        startDate: function (newValue) {
            this.startDate = newValue;
            console.log(this.startDate);
            this.init();
        },
        endDate: function (newValue) {
            this.endDate = newValue;
            console.log(this.endDate);
            this.init();
        },
        yearDate: function (newValue) {
            this.yearDate = newValue;
            console.log(this.yearDate);
            this.init();
        },
    },
    data() {
        return {
            centerId: '',
            monthList: [],
            monthValueList: [],
            startDate: moment().add(-1, 'M').format('MM'),
            endDate: moment().format('MM'),
            yearDate: moment().format('YYYY'),
            yearList: [],
            yearValueList: [],

            options: { chart: { id: 'vuechart-example' }, xaxis: { categories: [] }, markers: { size: [6] } },
            series: [{ name: 'series-1', data: [] }],
            colors: ['#F47E7C', '#4780FD', '#7ECC80', '#958CCB', '#5DA4C2', '#00C7E5'],

            options2: { chart: { id: 'vuechart-example' }, xaxis: { categories: [] }, markers: { size: [6] } },
            series2: [{ name: 'series-1', data: [] }],

            options3: { chart: { id: 'vuechart-example' }, xaxis: { categories: [] }, markers: { size: [6] } },
            series3: [{ name: 'series-1', data: [] }],

            options4: { chart: { id: 'vuechart-example' }, xaxis: { categories: [] }, markers: { size: [6] } },
            series4: [{ name: 'series-1', data: [] }],
        };
    },
    created() {
        this.createDate();
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        createDate() {
            //년도 자동생성
            for (let i = 0; i < 6; i++) {
                this.yearList.push(moment().subtract(i, 'y').format('YYYY년'));
                this.yearValueList.push(moment().subtract(i, 'y').format('YYYY'));
            }
            //월 자동생성
            for (let j = 1; j < 13; j++) {
                this.monthList.push(j + '월');
                this.monthValueList.push(('00' + j).slice(-2));
            }
        },
        //초기화
        async init() {
            try {
                await this.onStatSaleType();
                await this.onStatSaleTicket();
                await this.onStatSaleContract();
                await this.onStatSaleExpend();
            } catch (error) {
                console.log(error);
                console.log('초기화에 실패하였습니다.');
            }
        },

        //결제수단별 매출현황 조회
        async onStatSaleType() {
            try {
                const { data } = await this.getStatSaleType();
                console.log('결제수단별 매출현황 조회', data);

                const xaxis = data.reduce((re, d) => (re.includes(d.ccb_buy_dt) ? re : [...re, d.ccb_buy_dt]), []);
                const arr = Array(xaxis.length).fill(0);

                let series_array = [...arr]; //카드
                let series_array1 = [...arr]; //현금
                let series_array2 = [...arr]; //계좌이체
                let series_array3 = [...arr]; //기타
                let series_array4 = [...arr]; //마일리지
                let series_array5 = [...arr]; //핏페이

                data.forEach((g) => {
                    const index = xaxis.indexOf(g.ccb_buy_dt) || 0;

                    if (g.ccb_pay_type_cd == 'F') {
                        series_array4[index] = g.ccb_bill_price;
                    } else if (g.ccb_pay_type_cd == 'C') {
                        series_array[index] = g.ccb_bill_price;
                    } else if (g.ccb_pay_type_cd == 'B') {
                        series_array1[index] = g.ccb_bill_price;
                    } else if (g.ccb_pay_type_cd == 'L') {
                        series_array2[index] = g.ccb_bill_price;
                    } else if (g.ccb_pay_type_cd == 'M') {
                        series_array4[index] = g.ccb_bill_price;
                    } else if (g.ccb_pay_type_cd == 'T' || g.ccb_pay_type_cd == 'U') {
                        series_array5[index] = g.ccb_bill_price;
                    } else {
                        series_array3[index] = g.ccb_bill_price;
                    }
                });

                this.options = {
                    chart: {
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: [],
                            },
                        },
                    },
                    grid: { strokeDashArray: 10 },
                    xaxis: { categories: xaxis, axisBorder: { show: false } },
                    colors: this.colors,
                };
                this.series = [
                    {
                        name: '핏페이',
                        data: series_array5,
                    },
                    {
                        name: '카드',
                        data: series_array,
                    },
                    {
                        name: '현금',
                        data: series_array1,
                    },
                    {
                        name: '계좌이체',
                        data: series_array2,
                    },
                    {
                        name: '기타',
                        data: series_array3,
                    },
                    {
                        name: '마일리지',
                        data: series_array4,
                    },
                ];
            } catch (error) {
                console.log(error);
                console.log('결제수단별 매출현황 오류입니다.');
            }
        },
        //결제수단별 매출현황 조희 API
        getStatSaleType() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/pay-type`, {
                params: {
                    startDate: this.yearDate + this.startDate, //YYYYMM
                    endDate: this.yearDate + this.endDate, //YYYYMM
                },
            });
        },
        //이용권별 매출현황 조회
        async onStatSaleTicket() {
            try {
                const { data } = await this.getStatSaleTicket();
                console.log('이용권별 매출현황 조회', data);
                let xaxis = [];
                let price_array = []; //개인
                let price_array1 = []; //OT
                let price_array2 = []; //듀엣
                let price_array3 = []; //그룹
                let price_array4 = []; //쿠폰
                let price_array5 = []; //회원권
                let price_array6 = []; //운동복
                data.forEach((g) => {
                    if (xaxis.includes(g.ccp_buy_dt) != true) {
                        xaxis.push(g.ccp_buy_dt);
                    }
                    if (g.ccp_ticket_type_cd == 'P') {
                        price_array.push(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'O') {
                        price_array1.push(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'D') {
                        price_array2.push(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'G') {
                        price_array3.push(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'C') {
                        price_array4.push(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'T') {
                        price_array5.push(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'S') {
                        price_array5.push(g.ccp_total_bill_price);
                    }
                });
                this.options2 = {
                    chart: {
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: [],
                            },
                        },
                    },
                    grid: { strokeDashArray: 10 },
                    xaxis: { categories: xaxis.sort(), axisBorder: { show: false } },
                };
                this.series2 = [
                    {
                        name: '개인',
                        data: price_array,
                    },
                    {
                        name: 'OT',
                        data: price_array1,
                    },
                    {
                        name: '듀엣',
                        data: price_array2,
                    },
                    {
                        name: '그룹',
                        data: price_array3,
                    },
                    {
                        name: '쿠폰',
                        data: price_array4,
                    },
                    {
                        name: '회원권',
                        data: price_array5,
                    },
                    {
                        name: '운동복',
                        data: price_array6,
                    },
                ];
            } catch (error) {
                console.log(error);
                console.log('이용권별 매출현황 오류입니다.');
            }
        },
        //이용권별 매출현황 조회 API
        getStatSaleTicket() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/ticket-type`, {
                params: {
                    startDate: this.yearDate + this.startDate, //YYYYMM
                    endDate: this.yearDate + this.endDate, //YYYYMM
                },
            });
        },
        //신규 재등록현황 조회
        async onStatSaleContract() {
            try {
                const { data } = await this.getStatSaleContract();
                console.log('신규,재등록', data);

                let xaxis = [];
                let price_array = []; //신규
                let price_array1 = []; //재등록
                data.forEach((g) => {
                    if (xaxis.includes(g.cc_buy_dt) != true) {
                        xaxis.push(g.cc_buy_dt);
                    }
                    if (g.cc_contract_type_cd == 'N') {
                        price_array.push(g.cc_total_buy_price);
                    } else if (g.cc_contract_type_cd == 'R') {
                        price_array1.push(g.cc_total_buy_price);
                    }
                });
                this.options3 = {
                    chart: {
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: [],
                            },
                        },
                    },
                    grid: { strokeDashArray: 10 },
                    xaxis: { categories: xaxis, axisBorder: { show: false } },
                };
                this.series3 = [
                    {
                        name: '신규',
                        data: price_array,
                    },
                    {
                        name: '재등록',
                        data: price_array1,
                    },
                ];
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        //신규 재등록 현황 API
        getStatSaleContract() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/contract-type`, {
                params: {
                    startDate: this.yearDate + this.startDate, //YYYYMM
                    endDate: this.yearDate + this.endDate, //YYYYMM
                },
            });
        },
        //지출현황 조회
        async onStatSaleExpend() {
            try {
                const { data } = await this.getStatSaleExpend();
                console.log('지출현황 조회', data);

                let xaxis = [];
                let price_array = [];
                data.forEach((g) => {
                    xaxis.push(g.css_sale_year_month);
                    price_array.push(g.css_total_sale_price);
                });
                this.options4 = {
                    chart: {
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: [],
                            },
                        },
                    },
                    grid: { strokeDashArray: 10 },
                    xaxis: { categories: xaxis, axisBorder: { show: false } },
                };
                this.series4 = [
                    {
                        name: '테스트',
                        data: price_array,
                    },
                ];
            } catch (error) {
                console.log(error);
                console.log('지출현황 조회 에러');
            }
        },
        //지출현황 조회 API
        getStatSaleExpend() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/sale-stats`, {
                params: {
                    startDate: this.yearDate + this.startDate, //YYYYMM
                    endDate: this.yearDate + this.endDate, //YYYYMM
                },
            });
        },
    },
};
</script>
<style lang="scss"></style>
